<template>
    <div>
        <org
            :rootNode="rootNode"
            :app="app"
        >
            <template v-slot:before>
                <router-link to="/" class="underline">
                    &laquo; Back to Main Menu
                </router-link>

                <br><br>
            </template>
        </org>
    </div>
</template>

<script>
import Vue     from 'vue';
import Org     from '../org/component.vue';
import parse   from '../org-parser';
import demo    from './demo.org';

function swapDates(str) {
    var today = new Date(),
        tomorrow = new Date(),
        yesterday = new Date();

    tomorrow.setDate(tomorrow.getDate() + 1);
    yesterday.setDate(yesterday.getDate() - 1);

    str = str.replace(/\$TODAY/g, today.toISOString().split('T')[0]);
    str = str.replace(/\$TOMORROW/g, tomorrow.toISOString().split('T')[0]);
    str = str.replace(/\$YESTERDAY/g, yesterday.toISOString().split('T')[0]);

    return str;
}

export default {
    props: ['app'],

    components: {
        Org
    },

    computed: {
        rootNode() {
            var _ = this,
                root = new Vue({
                    data: {
                        type: 'root',
                        children: parse(swapDates(demo)),
                        isExpanded: true
                    }
                });

            _.app.expandNode(root);

            return root;
        }
    }
};
</script>
